/**
 * Canonical marketing / SEO constants for the public site.
 * Keep sitemap entries and page meta copy aligned with this file.
 */
export const SITE_URL = 'https://roomzza.com';

export const SITE_NAME = 'RoomZa';

export const DEFAULT_TITLE =
  'RoomZa | Find Roommates & Shared Homes in South Africa';

export const DEFAULT_DESCRIPTION =
  'RoomZa matches you with compatible roommates in Cape Town, Johannesburg, Durban, and across South Africa — then helps you discover homes that fit your shared budget.';

export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export const SITE_KEYWORDS = [
  'roommate finder South Africa',
  'find a roommate Cape Town',
  'roommate matching Johannesburg',
  'shared accommodation Durban',
  'flatmate finder',
  'RoomZa',
  'roomzza',
  'landlord tenant matching',
  'compatible roommates',
].join(', ');

export type PublicSitemapEntry = {
  path: string;
  changefreq: 'daily' | 'weekly' | 'monthly' | 'yearly';
  priority: number;
};

/** Indexable public routes for sitemap.xml */
export const PUBLIC_SITEMAP_ENTRIES: PublicSitemapEntry[] = [
  { path: '/', changefreq: 'weekly', priority: 1 },
  { path: '/how-it-works', changefreq: 'monthly', priority: 0.9 },
  { path: '/signup', changefreq: 'monthly', priority: 0.8 },
  { path: '/login', changefreq: 'yearly', priority: 0.4 },
  { path: '/legal/terms', changefreq: 'yearly', priority: 0.3 },
  { path: '/legal/privacy', changefreq: 'yearly', priority: 0.3 },
  { path: '/legal/community-guidelines', changefreq: 'yearly', priority: 0.3 },
  { path: '/legal/cookies', changefreq: 'yearly', priority: 0.2 },
  { path: '/legal/paia', changefreq: 'yearly', priority: 0.2 },
];

export const absoluteUrl = (path = '/'): string => {
  if (!path || path === '/') return `${SITE_URL}/`;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
};

export const pageTitle = (title?: string): string =>
  title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
